import React from 'react'

import { wave } from '@ui-kit/components/Wave/styles'
import { COLOR } from '@ui-kit/constants'
import { paddingY } from '@ui-kit/styles/padding'

import { SHAPE } from './shapes'
import type { Props } from './types'

const WaveSeparator = (props: Props): JSX.Element => {
  const space = props.space || 'none'
  const shape = SHAPE[props.shape || 'A']
  return (
    <div className={paddingY({ space })}>
      <svg
        className={wave({ flipX: props.flipX, flipY: props.flipY })}
        width="100%"
        viewBox={`0 0 375 ${shape.height}`}
        preserveAspectRatio="none"
      >
        <path d={shape.path} stroke={COLOR[props.color]} strokeWidth={1} fill="transparent" />
      </svg>
    </div>
  )
}

export default WaveSeparator
